<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('dashboard') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-row class="mt-2">
        <v-col cols="8">
          <div class="d-flex align-center">
            <div class="d-flex align-center">
              <div style="font-size: 30px; font-weight: 700">{{ $t('overview') }}</div>
              <div class="mx-3" style="background-color: #c9d6f2; height: 30px; width: 2px"></div>
              <span style="font-size: 18px" class="font-weight-medium mr-2">{{ $t('start_end_date') }}</span>
              <v-menu v-model="datePickerMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="auto">
                <template v-slot:activator="{ props }">
                  <v-text-field v-bind="props" :value="dateRangeText" readonly variant="outlined" density="compact"
                    hide-details style="width: 300px; position: relative">
                    <v-icon size="small" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
                      color="#76237E"> mdi-calendar </v-icon>
                  </v-text-field>
                </template>
                <v-card class="date-picker-card">
                  <v-date-picker v-model="selectedDates" @update:model-value="updateDateRange" color="#76237E"
                    elevation="0" rounded="lg" multiple="range" />
                  <v-card-actions class="date-picker-actions justify-end">
                    <v-btn variant="text" color="#666" @click="cancelDateSelection">Cancel</v-btn>
                    <v-btn variant="flat" color="#76237E" :disabled="!selectedDates.length || !hasDateSelectionChanged" @click="confirmDateSelection">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>
        </v-col>
        <v-col cols="4" class="d-flex justify-end">
          <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
            style="border-radius: 14px; height: 48px; background-color: #185c3715"
            @click="exportAllData">
            <v-img :src="images.excelIcon" width="20" height="20" />
            <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <!-- dashboard ui -->
      <!-- First Row -->
      <v-row class="mt-4">
        <v-col cols="6">
          <v-row>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #f4e3a9 0%, #ddfdff 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total messages</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">(answered)</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalMessages?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 5px; bottom: 5px; z-index: 1;"><v-img :src="images.userIcon" style="width: 80px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #ffe7f7 0%, #ffcbbe 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total messages Liked</div>
                <div class="card-value-bottom-left">{{ dashboardData?.percentTotalMessagesLiked || '0.00%' }}</div>
                <div style="position: absolute; right: 5px; bottom: 5px; z-index: 1;"><v-img :src="images.likeIcon" style="width: 80px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #E1F6FF 0%, #FCD7FF 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Visit CIFs</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">(unique)</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalVisitCIFs?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.cellphoneEyeIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #ffd2d4 0%, #d3d6ff 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Active CIFs</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">(unique)</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalActiveCIFs?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.bubbleIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #bbcaff 0%, #bcfbff 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Usage</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">(Session)</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalUsage?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.promptIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #d6dc29 0%, #c5ebff 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Proactive</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalProactive?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.chatIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Second Row -->
      <v-row class="mt-4">
        <v-col cols="6">
          <v-row>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #9ba4ff 0%, #cbc4ff 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Deep-link send</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalDeepLinkSend?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.sendIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #93ddff 0%, #98a1f9 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Deep-link click</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalDeepLinkClick?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.cursorIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #97f5ff 0%, #99cbe5 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Deep-link</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Completion Rate</div>
                <div class="card-value-bottom-left">{{ dashboardData?.percentDeepLinkCompletionRate || '0.00%' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.linkIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards"
                style="background: linear-gradient(270deg, #ced629 0%, #ecf26f 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Cases</div>
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Send to Agent</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalCasesSendToAgent?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.displayIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #F5BE49 0%, #F2F883 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total Clicks</div>
                <div class="card-value-bottom-left">{{ dashboardData?.totalClicks?.toLocaleString() || '0' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.cursorClickOrangeIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #ffc681 0%, #ffdd6f 100%);">
                <div style="font-size: 16px; position: relative; z-index: 2;" class="font-weight-medium">Total %CTR</div>
                <div class="card-value-bottom-left">{{ dashboardData?.percentTotalCTR || '0.00%' }}</div>
                <div style="position: absolute; right: 0; bottom: 0; z-index: 1;"><v-img :src="images.mouseIcon" style="width: 100px; opacity: 0.5;" /></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Third Row -->
      <v-row class="mt-4">
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <v-card-title class="d-flex justify-space-between align-center p-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Total Users by Date</h4>
            </v-card-title>
            <apexchart 
              type="bar" 
              height="300" 
              :options="userChartOptions" 
              :series="series"
              style="margin-top: -20px;"
            />
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <v-card-title class="d-flex justify-space-between align-center p-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Total Messages by Date</h4>
            </v-card-title>
            <apexchart 
              type="bar" 
              height="300" 
              :options="messagesChartOptions" 
              :series="messagesSeries"
              style="margin-top: -20px;"
            />
          </v-card>
        </v-col>
      </v-row>
      <!-- Fourth Row -->
      <v-row class="mt-4">
        <!-- Proactive Section -->
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <v-card-title class="d-flex justify-space-between align-center px-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Proactive Performance</h4>

              <div class="d-flex ga-2">
                <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                  style="border-radius: 14px; height: 40px; background-color: #185c3715"
                  @click="exportProactivePerformanceDetails">
                  <v-img :src="images.excelIcon" width="20" height="20" />
                  <span class="ml-2" style="font-weight: 700">Export Details</span>
                </v-btn>
                <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                  style="border-radius: 14px; height: 40px; background-color: #185c3715"
                  @click="exportProactivePerformance">
                  <v-img :src="images.excelIcon" width="20" height="20" />
                  <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
                </v-btn>
              </div>
            </v-card-title>

            <div class="d-flex align-center mt-3">
              <div class="text-center mr-6">
                <div style="width: 200px; height: 200px; position: relative">
                  <apexchart type="donut" width="200" height="200" :options="chartOptions" :series="chartSeries" />
                  <div
                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                    <div class="text-h5 font-weight-bold">{{ totalClicks }}</div>
                    <div class="text-caption">total clicks</div>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="performance-table">
                  <div class="table-header">
                    <div class="header-cell" style="flex: 5; text-align: left; padding-left: 16px;">Proactive Message</div>
                    <div class="header-cell" style="flex: 0.9;">Display</div>
                    <div class="header-cell" style="flex: 0.7;">Clicks</div>
                    <div class="header-cell" style="flex: 0.7;">%CTR</div>
                  </div>
                  <div class="table-body" style="max-height: 250px; min-height: 250px; overflow-y: auto;">
                    <div v-for="(item, index) in performanceData" :key="item.id" class="table-row"
                      :class="{ 'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0 }">
                      <div class="cell" style="flex: 5; justify-content: flex-start;">
                          <v-tooltip location="top" max-width="400">
                            <template v-slot:activator="{ props }">
                              <div :style="{
                                backgroundColor: item.color,
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                              }">
                              </div>
                              <div class="url-cell" style="margin-left: 8px;" v-bind="props">
                                {{ item.name || item.proactiveMessage }}
                                <v-chip v-if="item.deleted" size="x-small" color="error" variant="flat" class="ml-1">Deleted</v-chip>
                              </div>
                            </template>
                            <span>{{ item.name || item.proactiveMessage }}{{ item.deleted ? ' (Deleted)' : '' }}</span>
                          </v-tooltip>
                      </div>
                      <div class="cell data-cell" style="flex: 0.9;">{{ item.display }}</div>
                      <div class="cell data-cell" style="flex: 0.7;">{{ item.clicks }}</div>
                      <div class="cell data-cell" style="flex: 0.7;">{{ item.ctr }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <!-- Deep-link Rates Section -->
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <div class="mb-4">
              <v-card-title class="d-flex justify-space-between align-center px-0">
                <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Deep-link Performance</h4>

                <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                  style="border-radius: 14px; height: 40px; background-color: #185c3715"
                  @click="exportDeepLinkPerformance">
                  <v-img :src="images.excelIcon" width="20" height="20" />
                  <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
                </v-btn>
              </v-card-title>
            </div>
            <div class="deeplink-table mt-3">
              <div class="table-header">
                <div class="header-cell" style="flex: 1.2;">Name</div>
                <div class="header-cell" style="flex: 2;">Link</div>
                <div class="header-cell" style="flex: 0.8;">Display</div>
                <div class="header-cell" style="flex: 0.8;">Clicks</div>
                <div class="header-cell" style="flex: 1.3;">Completion Rate</div>
              </div>
              <div class="table-body" style="max-height: 250px; min-height: 250px; overflow-y: auto;">
                <div v-for="(item, index) in serviceData" :key="index" class="table-row"
                  :class="{ 'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0 }">
                  <div class="cell data-cell" style="flex: 1.2;">{{ item.name }}</div>
                  <v-tooltip location="top" max-width="400">
                    <template v-slot:activator="{ props }">
                      <div class="cell data-cell url-cell" style="flex: 2;" v-bind="props">{{ item.url || '...' }}</div>
                    </template>
                    <span>{{ item.url }}</span>
                  </v-tooltip>
                  <div class="cell data-cell" style="flex: 0.8;">{{ item.completed?.toLocaleString() || 0 }}</div>
                  <div class="cell data-cell" style="flex: 0.8;">{{ item.clicks?.toLocaleString() || 0 }}</div>
                  <div class="cell completion-rate" style="flex: 1.3;" :class="{ 'high-rate': parseFloat(item.rate) >= 5 }">
                    {{ item.rate }} 
                    <v-img v-if="parseFloat(item.rate) > 5" :src="images.upIcon" height="12" width="12" max-width="30" class="updownicon" />
                    <v-img v-if="parseFloat(item.rate) === 5" :src="images.equalIcon"  height="12" width="12" max-width="30" class="updownicon" />
                    <v-img v-if="parseFloat(item.rate) < 5" :src="images.downIcon" height="12" width="12" max-width="30" class="updownicon" />
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Fifth Row -->
      <v-row class="mt-4">
        <v-col cols="6">
          <v-card class="pa-5 d-card">
            <v-card-title class="d-flex justify-space-between align-center px-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">First Usage</h4>

              <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                style="border-radius: 14px; height: 40px; background-color: #185c3715"
                @click="exportFirstUsage">
                <v-img :src="images.excelIcon" width="20" height="20" />
                <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
              </v-btn>
            </v-card-title>
            <div class="first-usage-table mt-3">
              <div class="table-header">
                <div class="header-cell">CIF</div>
                <div class="header-cell">Proactive Message</div>
                <div class="header-cell">Click First Usage Date-Time</div>
              </div>
              <div class="table-body" style="max-height: 250px; min-height: 250px; overflow-y: auto;">
                <div v-for="(item, index) in messageData" :key="index" class="table-row"
                  :class="{ 'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0 }">
                  <div class="cell data-cell">{{ item.session }}</div>
                  <v-tooltip location="top" max-width="400">
                    <template v-slot:activator="{ props }">
                      <div class="cell data-cell url-cell" v-bind="props">
                        {{ item.messageId || '...' }}
                        <v-chip v-if="item.deleted" size="x-small" color="error" variant="flat" class="ml-1">Deleted</v-chip>
                      </div>
                    </template>
                    <span>{{ item.messageId }}{{ item.deleted ? ' (Deleted)' : '' }}</span>
                  </v-tooltip>
                  <div class="cell data-cell">{{ item.time }}</div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <v-card-title class="d-flex justify-space-between align-center px-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Likes log</h4>

              <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                style="border-radius: 14px; height: 40px; background-color: #185c3715"
                @click="exportLikesLog">
                <v-img :src="images.excelIcon" width="20" height="20" />
                <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
              </v-btn>
            </v-card-title>
            <div class="likes-logs-table mt-3">
              <div class="table-header">
                <div class="px-5" style="align-items: start; font-size: 14px; font-weight: bold; color: #9C9C9C;">
                  Message</div>
              </div>
              <div class="table-body" style="max-height: 250px; min-height: 250px; overflow-y: auto;">
                <div class="table-row" v-for="(item, index) in likelogData" :key="item.id"
                  :class="{ 'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0 }">
                  <div class="cell1 data-cell" style="padding: 0 16px; justify-content: flex-start;">
                    <v-tooltip location="top" max-width="400">
                      <template v-slot:activator="{ props }">
                        <div class="url-cell" v-bind="props">{{ item.message || '...' }}</div>
                      </template>
                      <span>{{ item.message }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>

          </v-card>
        </v-col>
      </v-row>
      <!-- Sixth row -->
      <v-row class="mt-4">
        <v-col cols="6">
          <v-card class="pa-4 d-card">
            <v-card-title class="d-flex justify-space-between align-center px-0">
              <h4 class="mb-3" style="font-weight: 700; font-size: 22px">Top 10 usage users</h4>

              <v-btn class="text-none" variant="outlined" color="#185C37" min-width="130"
                style="border-radius: 14px; height: 40px; background-color: #185c3715"
                @click="exportTop10UsageUsers">
                <v-img :src="images.excelIcon" width="20" height="20" />
                <span class="ml-2" style="font-weight: 700">{{ $t('export') }}</span>
              </v-btn>
            </v-card-title>
            <div class="likes-logs-table mt-3">
              <div class="table-header">
                <!-- <div class="header-cell">Proactive Message</div> -->
                <div class="header-cell">CIF</div>
                <div class="header-cell">Asked Times</div>
              </div>
              <div class="table-body" style="max-height: 250px; min-height: 250px; overflow-y: auto;">
                <div class="table-row" v-for="(item, index) in tableData" :key="item.id"
                  :class="{ 'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0 }">
                  <!-- <div class="cell data-cell" style="justify-content: flex-start;">
                    <v-tooltip location="top" max-width="400">
                      <template v-slot:activator="{ props }">
                        <div class="url-cell" v-bind="props">
                          {{ item.proactiveMessage || '...' }}
                          <v-chip v-if="item.deleted" size="x-small" color="error" variant="flat" class="ml-1">Deleted</v-chip>
                        </div>
                      </template>
                      <span>{{ item.proactiveMessage }}{{ item.deleted ? ' (Deleted)' : '' }}</span>
                    </v-tooltip>
                  </div> -->
                  <div class="cell data-cell">{{ item.cif }}</div>
                  <div class="cell data-cell">{{ item.askedTimes }}</div>
                </div>
              </div>
            </div>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :model-value="dialogLoading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import excelIcon from '@/assets/images/excel-icon.svg';
import userIcon from '@/assets/lhb/user.png';
import likeIcon from '@/assets/lhb/Group.svg';
import bubbleIcon from '@/assets/lhb/chat-bubble.png';
import promptIcon from '@/assets/lhb/prompt-session.png';
import chatIcon from '@/assets/lhb/chaticon.png';
import sendIcon from '@/assets/lhb/prime_send.svg';
import cursorIcon from '@/assets/lhb/cursorclick.svg';
import displayIcon from '@/assets/lhb/display.svg';
import cellphoneEyeIcon from '@/assets/lhb/cellphone-eye.svg';
import mouseIcon from '@/assets/lhb/mouse.svg';
import linkIcon from '@/assets/lhb/linkclick.svg';
import cursorClickOrangeIcon from '@/assets/lhb/streamline_cursor-click-orange.svg';
import upIcon from '@/assets/lhb/upicon.png';
import downIcon from '@/assets/lhb/downicon.png';
import equalIcon from '@/assets/lhb/equal.png';
import upArrow from '@/assets/lhb/uparrow.png';
import downArrow from '@/assets/lhb/downarrow.png';
import equalArrow from '@/assets/lhb/equalarrow.png';

import VueApexCharts from 'vue3-apexcharts';
import ExcelJS from 'exceljs';

export default {
  name: 'LHBDashboard',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {
      loading: false,
      flagNav: true,
      today: null,
      startDate: null,
      endDate: null,
      selectedDates: [],
      backupSelectedDates: [],
      datePickerMenu: false,
      lastSelectedDate: null,
      dashboardData: null,
      images: {
        excelIcon,
        userIcon,
        likeIcon,
        bubbleIcon,
        promptIcon,
        chatIcon,
        sendIcon,
        cursorIcon,
        linkIcon,
        cursorClickOrangeIcon,
        displayIcon,
        cellphoneEyeIcon,
        mouseIcon,
        upIcon,
        downIcon,
        equalIcon,
        upArrow,
        downArrow,
        
      },
      chartSeries: [],
      logs: [],
      performanceData: [],
      serviceData: [],
      messageData: [],
      tableData: [],
      likelogData: [],
      series: [],
      messagesSeries: [],
      userChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: ['#FFA500', '#A5A8ED'],
        dataLabels: {
          enabled: true,
          offsetY: -18,
          style: {
            fontSize: '12px',
            fontWeight: 600,
            colors: ['#333'],
          },
          formatter: function (val) {
            if (val === 0) return '';
            return val.toLocaleString();
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            borderRadius: 4,
            borderRadiusApplication: 'end',
            dataLabels: {
              position: 'top',
            },
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right',
          fontSize: '14px',
          fontWeight: 500,
          markers: {
            width: 10,
            height: 10,
            radius: 2,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
        },
        xaxis: {
          type: 'category',
          labels: {
            hideOverlappingLabels: true,
            showDuplicates: false,
            rotate: 0,
            style: {
              colors: '#666',
              fontSize: '12px',
              fontWeight: 500,
            },
          },
          axisBorder: { show: false },
          axisTicks: { show: true, color: '#e0e0e0' },
          tickPlacement: 'on',
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: '#666',
              fontSize: '12px',
              fontWeight: 500,
            },
            formatter: function (val) {
              return Math.round(val);
            },
          },
          axisBorder: { show: false },
          axisTicks: { show: false },
          min: 0,
          forceNiceScale: true,
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          x: { format: 'MMM dd' },
          y: {
            formatter: function (val) {
              return val.toLocaleString() + ' users';
            },
          },
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
      messagesChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: ['#7BC84D'],
        dataLabels: {
          enabled: true,
          offsetY: -18,
          style: {
            fontSize: '12px',
            fontWeight: 600,
            colors: ['#333'],
          },
          formatter: function (val) {
            if (val === 0) return '';
            return val.toLocaleString();
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            borderRadius: 4,
            borderRadiusApplication: 'end',
            dataLabels: {
              position: 'top',
            },
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right',
          fontSize: '14px',
          fontWeight: 500,
          markers: {
            width: 10,
            height: 10,
            radius: 2,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
        },
        xaxis: {
          type: 'category',
          labels: {
            hideOverlappingLabels: true,
            showDuplicates: false,
            rotate: 0,
            style: {
              colors: '#666',
              fontSize: '12px',
              fontWeight: 500,
            },
          },
          axisBorder: { show: false },
          axisTicks: { show: true, color: '#e0e0e0' },
          tickPlacement: 'on',
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: '#666',
              fontSize: '12px',
              fontWeight: 500,
            },
            formatter: function (val) {
              return Math.round(val);
            },
          },
          axisBorder: { show: false },
          axisTicks: { show: false },
          min: 0,
          forceNiceScale: true,
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          x: { format: 'MMM dd' },
          y: {
            formatter: function (val) {
              return val.toLocaleString() + ' messages';
            },
          },
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
      visitors: [5, 8, 6, 12, 14, 20, 18, 25],
      chartOptions: {
        chart: {
          type: 'donut',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        colors: ['#7BC84D', '#FFC107', '#FF7043', '#9E9E9E', '#757575'],
        labels: ['M001', 'M002', 'M003', 'M004', 'M005'],
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#333',
                  offsetY: -5,
                  formatter: function (val) {
                    return val;
                  },
                },
                value: {
                  show: false,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#666',
                  formatter: function (w) {
                    const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    return total;
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (value, opts) {
              if (!opts || !opts.w || !opts.w.globals || !opts.w.globals.seriesTotals) {
                return `${value} clicks`;
              }
              const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              if (total === 0) {
                return `${value} clicks`;
              }
              const percentage = ((value / total) * 100).toFixed(1);
              return `${value} clicks (${percentage}%)`;
            },
          },
          style: {
            fontSize: '12px',
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          },
        ],
      },
      dialogLoading: false,
    };
  },
  watch: {
    datePickerMenu(newVal) {
      if (newVal) {
        // Backup current selectedDates when menu opens
        this.backupSelectedDates = [...this.selectedDates];
      }
    },
  },
  computed: {
    dateRangeText() {
      if (this.startDate && this.endDate) {
        return `${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)}`;
      }
      return 'Select date range';
    },
    totalClicks() {
      if (!this.chartSeries || this.chartSeries.length === 0) {
        return 0;
      }
      return this.chartSeries.reduce((sum, value) => sum + value, 0);
    },
    // Check if date selection has changed from backup (when menu opened)
    hasDateSelectionChanged() {
      if (!this.selectedDates.length && !this.backupSelectedDates.length) {
        return false;
      }
      if (this.selectedDates.length !== this.backupSelectedDates.length) {
        return true;
      }
      // Compare arrays
      const sortedCurrent = [...this.selectedDates].sort();
      const sortedBackup = [...this.backupSelectedDates].sort();
      return JSON.stringify(sortedCurrent) !== JSON.stringify(sortedBackup);
    },
  },
  methods: {
    resetDashboardData() {
      // Reset all dashboard data to initial state
      this.dashboardData = null;
      this.serviceData = [];
      this.messageData = [];
      this.tableData = [];
      this.likelogData = [];
      this.performanceData = [];
      this.series = [];
      this.messagesSeries = [];
      this.chartSeries = [];
      
      // Reset chart options to default
      this.chartOptions = {
        ...this.chartOptions,
        labels: ['M001', 'M002', 'M003', 'M004', 'M005']
      };
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();

      // Format for display (DD/MM/YYYY)
      const ddStr = String(dd).padStart(2, '0');
      const mmStr = String(mm).padStart(2, '0');
      this.today = ddStr + '/' + mmStr + '/' + yyyy;

      // Initialize date picker with current date for both start and end (yyyy-MM-dd)
      const currentDate = `${yyyy}-${mmStr}-${ddStr}`;
      this.startDate = currentDate;
      this.endDate = currentDate;

      // Initialize selected dates array
      this.selectedDates = [this.startDate, this.endDate];
    },
    async loadDashboardData() {
      try {
        // Reset dashboard data before loading new data
        this.resetDashboardData();
        
        this.loading = true;
        this.dialogLoading = true;
        const request = {
          startDate: this.startDate,
          endDate: this.endDate
        };

        this.$call.GetDashboardLHB(
          request,
          (response) => {
            if (response && response.data) {
              this.dashboardData = response.data;
              // Update Deep-link Performance data
              if (this.dashboardData.listDeepLinkPerformance) {
                this.serviceData = this.dashboardData.listDeepLinkPerformance.map(item => ({
                  name: item.deepLink || '',
                  url: item.url || '',
                  clicks: item.countClick || 0,
                  completed: item.countDisplay || 0,
                  rate: item.percentCompletionRate || '0%'
                }));
              }
              
              // Update First Usage data
              if (this.dashboardData.listFirstUsage) {
                console.log('First Usage Data:', this.dashboardData.listFirstUsage);
                this.messageData = this.dashboardData.listFirstUsage.map(item => ({
                  session: item.cif || '',
                  messageId: item.proactiveMessage || '',
                  deleted: !item.activeFlag || false,
                  time: this.formatDateTime(item.createDate)
                }));
              }
              
              // Update Proactive Performance data
              if (this.dashboardData.listProactivePerformance) {
                const colors = ['#7bc84d', '#ffc107', '#ff7043', '#9e9e9e', '#757575'];
                this.performanceData = this.dashboardData.listProactivePerformance.map((item, index) => ({
                  id: item.id || '',
                  name: item.name || '',
                  proactiveMessage: item.proactiveMessage || '',
                  deleted: !item.activeFlag || false,
                  display: item.countDisplay || 0,
                  clicks: item.countClicks || 0,
                  ctr: item.percentCTR || '0%',
                  screen: item.screen || '',
                  cifCount: item.cifCount || 0,
                  color: colors[index % colors.length]
                }));
                
                // Update chart series for donut chart
                this.chartSeries = this.performanceData.map(item => item.clicks);
                
                // Update chart labels
                this.chartOptions = {
                  ...this.chartOptions,
                  labels: this.performanceData.map(item => item.name)
                };
              }

              if (this.dashboardData.listTotalUsers && this.dashboardData.listTotalUsers.length > 0) {
                const updatedSeries = this.dashboardData.listTotalUsers
                  .map(item => ({
                    name: item.name || '',
                    data: this.getTotalUsersPoints(item.data || []),
                  }))
                  .filter(item => item.data.length > 0);
                if (updatedSeries.length > 0) {
                  this.series = updatedSeries;
                }
              }
              
              if (this.dashboardData.listTotalMessages && this.dashboardData.listTotalMessages.length > 0) {
                const updatedMessagesSeries = this.dashboardData.listTotalMessages
                  .map(item => ({
                    name: item.name || '',
                    data: this.getTotalUsersPoints(item.data || []),
                  }))
                  .filter(item => item.data.length > 0);
                if (updatedMessagesSeries.length > 0) {
                  this.messagesSeries = updatedMessagesSeries;
                }
              }

              if (this.dashboardData.listLikesLogs) {
                this.likelogData = this.dashboardData.listLikesLogs.map(item => ({
                  id: item.logID || item.id || '',
                  message: item.message || ''
                }));
              } else {
                this.likelogData = [];
              }

              if (this.dashboardData.listTop10UsageUser) {
                this.tableData = this.dashboardData.listTop10UsageUser.map(item => ({
                  id: item.proactiveMessageID || '',
                  proactiveMessage: item.proactiveMessage || '',
                  deleted: !item.activeFlag || false,
                  cif: item.cif || '',
                  askedTimes: item.percentAskedTimes || ''
                }));
              } else {
                this.tableData = [];
              }
            }
              this.loading = false;
              this.dialogLoading = false;
          },
          (error) => {
            console.error('Error loading dashboard data:', error);
            this.loading = false;
            this.dialogLoading = false;
          }
        );
      } catch (error) {
        console.error('Error in loadDashboardData:', error);
        this.loading = false;
        this.dialogLoading = false;
      }
    },
    updateDateRange(dates) {
      if (dates && dates.length > 0) {
        // Sort dates to ensure proper start and end
        const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
        // Normalize to `yyyy-MM-dd` to match GetDate format
        const start = this.formatStateDate(sortedDates[0]);
        const end = this.formatStateDate(sortedDates[sortedDates.length - 1]);
        this.startDate = start;
        this.endDate = end;

        // If only one date selected, check if user wants single day
        if (sortedDates.length === 1) {
          this.endDate = this.startDate;
          const single = this.formatStateDate(sortedDates[0]);
          // If same date clicked twice, confirm single day selection
          if (this.lastSelectedDate === single) {
            this.datePickerMenu = false;
            this.loadDashboardData();
            this.lastSelectedDate = null;
            return;
          }
          this.lastSelectedDate = single;
        }

        // Close menu after selection of 2 dates (range selection)
        if (sortedDates.length >= 2) {
          this.datePickerMenu = false;
          this.lastSelectedDate = null;
          // Reload dashboard data when date range changes
          this.loadDashboardData();
        }
      } else {
        // When dates array is empty (user clicked same date to cancel)
        // Use the last selected date as single day selection
        if (this.lastSelectedDate) {
          this.startDate = this.lastSelectedDate;
          this.endDate = this.lastSelectedDate;
          this.selectedDates = [this.lastSelectedDate, this.lastSelectedDate];
          this.datePickerMenu = false;
          this.loadDashboardData();
          this.lastSelectedDate = null;
        }
      }
    },
    // Confirm date selection via OK button (same algorithm as double-click)
    confirmDateSelection() {
      if (this.selectedDates && this.selectedDates.length > 0) {
        // Use existing selection - same as updateDateRange logic
        const sortedDates = [...this.selectedDates].sort((a, b) => new Date(a) - new Date(b));
        this.startDate = this.formatStateDate(sortedDates[0]);
        this.endDate = this.formatStateDate(sortedDates[sortedDates.length - 1]);
        this.selectedDates = [this.startDate, this.endDate];
        this.datePickerMenu = false;
        this.lastSelectedDate = null;
        this.loadDashboardData();
      } else if (this.lastSelectedDate) {
        // If no selection but has lastSelectedDate, use it as single day (same as empty dates in updateDateRange)
        this.startDate = this.lastSelectedDate;
        this.endDate = this.lastSelectedDate;
        this.selectedDates = [this.lastSelectedDate, this.lastSelectedDate];
        this.datePickerMenu = false;
        this.loadDashboardData();
        this.lastSelectedDate = null;
      }
    },
    // Cancel date selection - restore to backup (state when menu was opened)
    cancelDateSelection() {
      // Restore selectedDates from backup (captured when menu opened)
      this.selectedDates = [...this.backupSelectedDates];
      this.datePickerMenu = false;
      this.lastSelectedDate = null;
    },
    // Normalize any incoming date (Date object or string) to `yyyy-MM-dd`
    formatStateDate(d) {
      if (!d) return null;
      const dt = typeof d === 'string' ? new Date(d) : d instanceof Date ? d : new Date(d);
      if (Number.isNaN(dt.getTime())) return null;
      const yyyy = dt.getFullYear();
      const mm = String(dt.getMonth() + 1).padStart(2, '0');
      const dd = String(dt.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    formatDisplayDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getTotalUsersPoints(points = []) {
      return points
        .map(point => {
          if (!point) return null;
          const value = Number(point.countUser ?? 0);
          if (point.dateTimeString) {
            const parsedDate = new Date(point.dateTimeString);
            if (!Number.isNaN(parsedDate.getTime())) {
              // Format date as 'MMM dd' for category axis
              const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              const month = monthNames[parsedDate.getMonth()];
              const day = String(parsedDate.getDate()).padStart(2, '0');
              return { x: `${month} ${day}`, y: value };
            }
            return { x: point.dateTimeString, y: value };
          }
          return null;
        })
        .filter(Boolean);
    },
    // Export helper function
    async downloadExcel(workbook, filename) {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
    },
    // Style header row helper
    styleHeaderRow(worksheet, headerRow) {
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF185C37' }
        };
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFFFF' },
          size: 12
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });
    },
    // Style data rows helper
    styleDataRows(worksheet, startRow, endRow) {
      for (let i = startRow; i <= endRow; i++) {
        const row = worksheet.getRow(i);
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
          };
          cell.alignment = { vertical: 'middle' };
        });
        // Alternate row colors
        if (i % 2 === 0) {
          row.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFF9F9F9' }
            };
          });
        }
      }
    },
    // Format screen list for Excel cell
    formatScreenBulletList(screenValue) {
      if (!screenValue) {
        return '';
      }

      let screenList = [];
      if (Array.isArray(screenValue)) {
        screenList = screenValue;
      } else if (typeof screenValue === 'string') {
        try {
          const parsed = JSON.parse(screenValue);
          if (Array.isArray(parsed)) {
            screenList = parsed;
          }
        } catch (e) {
          screenList = [screenValue];
        }
      } else {
        screenList = [String(screenValue)];
      }

      return screenList
        .filter(item => item !== null && item !== undefined && String(item).trim() !== '')
        .map(item => `• ${String(item).trim()}`)
        .join('\n');
    },
    // Export All Data
    async exportAllData() {
      try {
        this.dialogLoading = true;
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'LHB Dashboard';
        workbook.created = new Date();
        
        const dateRange = `${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)}`;
        
        // Sheet 1: Overview Summary
        const summarySheet = workbook.addWorksheet('Overview Summary');
        summarySheet.columns = [
          { header: 'Metric', key: 'metric', width: 30 },
          { header: 'Value', key: 'value', width: 20 }
        ];
        
        const summaryData = [
          { metric: 'Date Range', value: dateRange },
          { metric: 'Total Messages (Answered)', value: this.dashboardData?.totalMessages?.toLocaleString() || '0' },
          { metric: 'Total Messages Liked', value: this.dashboardData?.percentTotalMessagesLiked || '0%' },
          { metric: 'Total Visit CIFs (Unique)', value: this.dashboardData?.totalVisitCIFs?.toLocaleString() || '0' },
          { metric: 'Total Active CIFs (Unique)', value: this.dashboardData?.totalActiveCIFs?.toLocaleString() || '0' },
          { metric: 'Total Usage (Session)', value: this.dashboardData?.totalUsage?.toLocaleString() || '0' },
          { metric: 'Total Proactive', value: this.dashboardData?.totalProactive?.toLocaleString() || '0' },
          { metric: 'Total Deep-link Send', value: this.dashboardData?.totalDeepLinkSend?.toLocaleString() || '0' },
          { metric: 'Total Deep-link Click', value: this.dashboardData?.totalDeepLinkClick?.toLocaleString() || '0' },
          { metric: 'Deep-link Completion Rate', value: (this.dashboardData?.deepLinkCompletionRate?.toLocaleString() || '0') + '%' },
          { metric: 'Total Cases Send to Agent', value: this.dashboardData?.totalCasesSendToAgent?.toLocaleString() || '0' },
          { metric: 'Total Clicks', value: this.dashboardData?.totalClicks?.toLocaleString() || '0' },
          { metric: 'Total %CTR', value: (this.dashboardData?.percentTotalCTR || '0') + '%' }
        ];
        
        summaryData.forEach(item => summarySheet.addRow(item));
        this.styleHeaderRow(summarySheet, summarySheet.getRow(1));
        this.styleDataRows(summarySheet, 2, summaryData.length + 1);
        
        // Sheet 2: Total Users and Messages by Date
        if (this.series && this.series.length > 0) {
          const usersSheet = workbook.addWorksheet('Total Users and Messages by Date');
          usersSheet.columns = [
            { header: 'Date', key: 'date', width: 15 },
            { header: 'Data Type', key: 'dataType', width: 20 },
            { header: 'Count', key: 'count', width: 15 }
          ];
          
          let usersRowCount = 1;
          this.series.forEach(seriesItem => {
            if (seriesItem.data) {
              seriesItem.data.forEach(point => {
                usersSheet.addRow({
                  date: point.x,
                  dataType: seriesItem.name,
                  count: point.y
                });
                usersRowCount++;
              });
            }
          });
          
          this.styleHeaderRow(usersSheet, usersSheet.getRow(1));
          this.styleDataRows(usersSheet, 2, usersRowCount);
        }
        
        // Sheet 3: Proactive Performance
        const proactiveSheet = workbook.addWorksheet('Proactive Performance');
        proactiveSheet.columns = [
          { header: 'Message ID', key: 'messageId', width: 20 },
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'Display', key: 'display', width: 15 },
          { header: 'Clicks', key: 'clicks', width: 15 },
          { header: '%CTR', key: 'ctr', width: 15 }
        ];
        
        this.performanceData.forEach(item => {
          proactiveSheet.addRow({
            messageId: item.id,
            proactiveMessage: item.proactiveMessage,
            display: item.display,
            clicks: item.clicks,
            ctr: item.ctr
          });
        });
        
        this.styleHeaderRow(proactiveSheet, proactiveSheet.getRow(1));
        this.styleDataRows(proactiveSheet, 2, this.performanceData.length + 1);
        
        // Sheet 4: Deep-link Performance
        const deepLinkSheet = workbook.addWorksheet('Deep-link Performance');
        deepLinkSheet.columns = [
          { header: 'Name', key: 'name', width: 25 },
          { header: 'Link', key: 'url', width: 50 },
          { header: 'Display', key: 'completed', width: 15 },
          { header: 'Clicks', key: 'clicks', width: 15 },
          { header: 'Completion Rate', key: 'rate', width: 20 }
        ];
        
        this.serviceData.forEach(item => {
          deepLinkSheet.addRow({
            name: item.name,
            url: item.url,
            completed: item.completed,
            clicks: item.clicks,
            rate: item.rate
          });
        });
        
        this.styleHeaderRow(deepLinkSheet, deepLinkSheet.getRow(1));
        this.styleDataRows(deepLinkSheet, 2, this.serviceData.length + 1);
        
        // Sheet 5: First Usage
        const firstUsageSheet = workbook.addWorksheet('First Usage');
        firstUsageSheet.columns = [
          { header: 'CIF', key: 'cif', width: 20 },
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'First Usage Date-time', key: 'dateTime', width: 25 }
        ];
        
        this.messageData.forEach(item => {
          firstUsageSheet.addRow({
            cif: item.session,
            proactiveMessage: item.messageId || '-',
            dateTime: item.time
          });
        });
        
        this.styleHeaderRow(firstUsageSheet, firstUsageSheet.getRow(1));
        this.styleDataRows(firstUsageSheet, 2, this.messageData.length + 1);
        
        // Sheet 6: Likes Log
        const likesSheet = workbook.addWorksheet('Likes Log');
        likesSheet.columns = [
          { header: 'Message', key: 'message', width: 80 }
        ];
        
        this.likelogData.forEach(item => {
          likesSheet.addRow({ message: item.message });
        });
        
        this.styleHeaderRow(likesSheet, likesSheet.getRow(1));
        this.styleDataRows(likesSheet, 2, this.likelogData.length + 1);
        
        // Sheet 7: Top 10 Usage Users
        const top10Sheet = workbook.addWorksheet('Top 10 Usage Users');
        top10Sheet.columns = [
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'CIF', key: 'cif', width: 20 },
          { header: 'Asked Times', key: 'askedTimes', width: 20 }
        ];
        
        this.tableData.forEach(item => {
          top10Sheet.addRow({
            proactiveMessage: item.proactiveMessage || '-',
            cif: item.cif,
            askedTimes: item.askedTimes
          });
        });
        
        this.styleHeaderRow(top10Sheet, top10Sheet.getRow(1));
        this.styleDataRows(top10Sheet, 2, this.tableData.length + 1);
        
        // Download file
        const filename = `LHB_Dashboard_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting all data:', error);
        this.dialogLoading = false;
      }
    },
    // Export Proactive Performance
    async exportProactivePerformance() {
      try {
        this.dialogLoading = true;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Proactive Performance');
        
        worksheet.columns = [
          { header: 'Name', key: 'name', width: 35 },
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'Display', key: 'display', width: 15 },
          { header: 'Clicks', key: 'clicks', width: 15 },
          { header: '%CTR', key: 'ctr', width: 15 }
        ];
        
        this.performanceData.forEach(item => {
          worksheet.addRow({
            name: item.name,
            proactiveMessage: item.proactiveMessage,
            display: item.display,
            clicks: item.clicks,
            ctr: item.ctr
          });
        });

        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, this.performanceData.length + 1);
        
        const filename = `Proactive_Performance_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting proactive performance:', error);
        this.dialogLoading = false;
      }
    },
    // Export Proactive Performance Details (includes Screen and CIF Count)
    async exportProactivePerformanceDetails() {
      try {
        this.dialogLoading = true;
        const request = {
          startDate: this.startDate,
          endDate: this.endDate
        };

        const exportPerformanceData = await new Promise((resolve, reject) => {
          this.$call.GetExportProactivePerformanceDetails(
            request,
            (response) => {
              const list = response && response.data ? response.data : [];
              const mapped = list.map(item => ({
                messageId: item.proactiveMessageID || '',
                name: item.name || '',
                messageEnglish: item.messageEnglish || '',
                cifNo: item.cifNo || '',
                display: item.displayCount || 0,
                clicks: item.displayMessageClicked || 0,
                // screen: item.screen || '',
              }));
              resolve(mapped);
            },
            (error) => reject(error)
          );
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Proactive Performance Details');
        
        worksheet.columns = [
          { header: 'Message ID', key: 'messageId', width: 40 },
          // { header: 'Name', key: 'name', width: 30 },
          { header: 'Message English', key: 'messageEnglish', width: 50 },
          { header: 'CIF No', key: 'cifNo', width: 20 },
          { header: 'Display', key: 'display', width: 15 },
          { header: 'Clicks', key: 'clicks', width: 15 },
          // { header: 'Screen', key: 'screen', width: 20 },
        ];
        
        exportPerformanceData.forEach(item => {
          worksheet.addRow({
            messageId: item.name || '-',
            // name: item.name,
            messageEnglish: item.messageEnglish || '-',
            cifNo: item.cifNo || '-',
            display: (item.display !== null && item.display !== undefined && item.display !== '') ? item.display : '-',
            clicks: (item.clicks !== null && item.clicks !== undefined && item.clicks !== '') ? item.clicks : '-',
            // screen: item.screen || '-'
            }); 
          });
       
        
        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, exportPerformanceData.length + 1);
        
        const filename = `Proactive_Performance_Details_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting proactive performance details:', error);
        this.dialogLoading = false;
      }
    },
    // Export Deep-link Performance
    async exportDeepLinkPerformance() {
      try {
        this.dialogLoading = true;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Deep-link Performance');
        
        worksheet.columns = [
          { header: 'Name', key: 'name', width: 25 },
          { header: 'Link', key: 'url', width: 50 },
          { header: 'Display', key: 'completed', width: 15 },
          { header: 'Clicks', key: 'clicks', width: 15 },
          { header: 'Completion Rate', key: 'rate', width: 20 }
        ];
        
        this.serviceData.forEach(item => {
          worksheet.addRow({
            name: item.name,
            url: item.url,
            completed: item.completed,
            clicks: item.clicks,
            rate: item.rate
          });
        });
        
        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, this.serviceData.length + 1);
        
        const filename = `DeepLink_Performance_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting deep-link performance:', error);
        this.dialogLoading = false;
      }
    },
    // Export First Usage
    async exportFirstUsage() {
      try {
        this.dialogLoading = true;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('First Usage');
        
        worksheet.columns = [
          { header: 'CIF', key: 'cif', width: 20 },
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'First Usage Date-time', key: 'dateTime', width: 25 }
        ];
        
        this.messageData.forEach(item => {
          worksheet.addRow({
            cif: item.session,
            proactiveMessage: item.messageId || '-',
            dateTime: item.time
          });
        });
        
        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, this.messageData.length + 1);
        
        const filename = `First_Usage_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting first usage:', error);
        this.dialogLoading = false;
      }
    },
    // Export Likes Log
    async exportLikesLog() {
      try {
        this.dialogLoading = true;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Likes Log');
        
        worksheet.columns = [
          { header: 'Message', key: 'message', width: 80 }
        ];
        
        this.likelogData.forEach(item => {
          worksheet.addRow({ message: item.message });
        });
        
        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, this.likelogData.length + 1);
        
        const filename = `Likes_Log_${this.startDate}_to_${this.endDate}.xlsx`;
        await this.downloadExcel(workbook, filename);
        
        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting likes log:', error);
        this.dialogLoading = false;
      }
    },
    // Export Top 10 Usage Users
    async exportTop10UsageUsers() {
      try {
        this.dialogLoading = true;

        const exportData = await new Promise((resolve, reject) => {
          this.$call.GetExportUsageUsers(
            (response) => {
              const list = response && response.data ? response.data : [];
              const mapped = list.map(item => ({
                proactiveMessage: item.proactiveMessage || '-',
                cif: item.cif || '-',
                askedTimes: item.percentAskedTimes || '-'
              }));
              resolve(mapped);
            },
            (error) => reject(error)
          );
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Usage Users');

        worksheet.columns = [
          { header: 'CIF', key: 'cif', width: 20 },
          { header: 'Proactive Message', key: 'proactiveMessage', width: 50 },
          { header: 'Asked Times', key: 'askedTimes', width: 20 }
        ];

        exportData.forEach(item => {
          worksheet.addRow({
            cif: item.cif,
            proactiveMessage: item.proactiveMessage,
            askedTimes: item.askedTimes
          });
        });

        this.styleHeaderRow(worksheet, worksheet.getRow(1));
        this.styleDataRows(worksheet, 2, exportData.length + 1);

        const filename = `Usage_Users_Export.xlsx`;
        await this.downloadExcel(workbook, filename);

        this.dialogLoading = false;
      } catch (error) {
        console.error('Error exporting usage users:', error);
        this.dialogLoading = false;
      }
    },
  },
  mounted() {
    this.GetDate();
    this.loadDashboardData();
  },
};
</script>

<style scoped>
* {
  box-shadow: none !important;
}

.d-card {
  border-radius: 15px;
  background: #f9f9f9;
  min-height: 420px !important;
}

/* Icon Styles */
.icon1 {
  width: 100px;
}

/* Beautiful Performance Table Styles */
.performance-table,
.deeplink-table,
.first-usage-table,
.likes-logs-table {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: flex;
  background: #ffffff;
  /* border-bottom: 2px solid #dee2e6; */
  padding: 12px 0;
}

.table-body .even-row {
  background-color: #ffffff;
}

.table-body .odd-row {
  background-color: #f9f9f9;
}

.header-cell {
  flex: 1;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #9C9C9C;
  letter-spacing: 0.5px;
  padding: 0 8px;
}

.table-body {
  background: #fff;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f4;
  transition: all 0.2s ease;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.table-row:last-child {
  border-bottom: none;
}

.cell {
  flex: 1;
  text-align: center;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cell1 {
  flex: 1;
  text-align: center;
  padding: 0 10px;
  display: flex;
  justify-content: start;
  align-items: center;
  min-width: 0;
}
.data-cell {
  font-size: 13px;
  font-weight: 500;
  color: #000000;
}

.url-cell {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block !important;
  width: 100%;
  max-width: 100%;
  text-align: left !important;
}

/* Scrollbar styling */
.table-body::-webkit-scrollbar {
  width: 8px;
}

.table-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.message-chip,
.deeplink-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  padding: 0 8px;
  min-width: 45px;
  white-space: nowrap;
}

.message-chip {
  width: 45px;
}

.deeplink-chip {
  min-width: 70px;
  max-width: 100px;
}

.deeplink-chip-neutral {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  padding: 0 8px;
  min-width: 70px;
  max-width: 100px;
  white-space: nowrap;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  transition: all 0.3s ease;
}

.deeplink-chip-neutral:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
}

.chip-text {
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.chip-text-neutral {
  color: #495057;
  font-weight: 600;
}

.completion-rate {
  font-weight: 600;
  color: #dc3545;
}

.completion-rate.high-rate {
  color: #28a745;
}
.updownicon.v-img.v-img__img {
  width: 12px!important;
  height: 12px!important;
}
/* Custom table styling */
.v-simple-table {
  border-radius: 8px;
}

.v-simple-table th {
  font-weight: 600 !important;
  color: #666 !important;
}

.dashboard-top-cards {
  border-radius: 12px;
  height: 120px;
  position: relative;
  overflow: hidden;
}

.card-value-bottom-left {
  position: absolute;
  bottom: 0px;
  left: 16px;
  z-index: 2;
  font-weight: 700;
  font-size: 35px;
}

/* ApexCharts custom styling */
:deep(.apexcharts-tooltip) {
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

:deep(.apexcharts-datalabel-label) {
  font-weight: 600 !important;
  font-size: 12px !important;
}

:deep(.apexcharts-datalabel-value) {
  font-weight: 700 !important;
  font-size: 24px !important;
}

/* Date Picker Custom Styling - Force override all Vuetify styles */
:deep(.v-date-picker) {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Remove horizontal gaps between days but keep small row spacing */
:deep(.v-date-picker-month__days) {
  column-gap: 0 !important;
  row-gap: 6px !important;
}

:deep(.v-date-picker-month__day) {
  padding: 0 !important;
  margin: 0 !important;
}

:deep(.v-date-picker-month__day .v-btn) {
  margin: 0 !important;
  padding: 0 !important;
  min-width: 40px !important;
  width: 100% !important;
  height: 40px !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
}

/* Override Vuetify's default circular style for selected dates */
:deep(.v-date-picker-month__day--selected .v-btn),
:deep(.v-date-picker-month__day--selected .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--selected .v-btn.v-btn--variant-flat) {
  background-color: rgba(118, 35, 126, 0.7) !important;
  border-radius: 8px !important;
}

/* Middle dates in range - no rounded corners for horizontal connection */
:deep(.v-date-picker-month__day--selected:not(.v-date-picker-month__day--range-start):not(.v-date-picker-month__day--range-end) .v-btn),
:deep(.v-date-picker-month__day--selected:not(.v-date-picker-month__day--range-start):not(.v-date-picker-month__day--range-end) .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--selected:not(.v-date-picker-month__day--range-start):not(.v-date-picker-month__day--range-end) .v-btn.v-btn--variant-flat),
:deep(.v-date-picker-month__day--in-range .v-btn) {
  border-radius: 0 !important;
  background-color: rgba(118, 35, 126, 0.7) !important;
}

/* Range start - rounded left corners only */
:deep(.v-date-picker-month__day--range-start .v-btn),
:deep(.v-date-picker-month__day--range-start .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-start .v-btn.v-btn--variant-flat) {
  border-radius: 12px 0 0 12px !important;
  background-color: #76237E !important;
}

/* Range end - rounded right corners only */
:deep(.v-date-picker-month__day--range-end .v-btn),
:deep(.v-date-picker-month__day--range-end .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-end .v-btn.v-btn--variant-flat) {
  border-radius: 0 12px 12px 0 !important;
  background-color: #76237E !important;
}

/* When start and end are same day - fully rounded */
:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn),
:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn.v-btn--variant-flat) {
  border-radius: 12px !important;
  background-color: #76237E !important;
}

/* Ensure currently focused day in the picker matches range styling */
:deep(.v-date-picker-month__day--active .v-btn) {
  background-color: #76237E !important;
  color: #fff !important;
  border-radius: 12px !important;
}

/* Text colors */
:deep(.v-date-picker-month__day--selected .v-btn) {
  color: white !important;
  font-weight: 500 !important;
}

:deep(.v-date-picker-month__day--range-start .v-btn),
:deep(.v-date-picker-month__day--range-end .v-btn) {
  color: white !important;
  font-weight: 600 !important;
}

/* Hover effect for non-selected dates */
:deep(.v-date-picker-month__day:not(.v-date-picker-month__day--selected) .v-btn:hover) {
  background-color: rgba(118, 35, 126, 0.1) !important;
  border-radius: 8px !important;
}

/* Remove overlay effects */
:deep(.v-date-picker-month__day .v-btn .v-btn__overlay) {
  opacity: 0 !important;
}

:deep(.v-date-picker-month__day .v-btn .v-ripple__container) {
  opacity: 0.3 !important;
}

/* Additional overrides */
:deep(.v-picker__body) {
  background: white !important;
}

:deep(.v-date-picker-month) {
  padding: 0 12px !important;
}

:deep(.v-date-picker-header) {
  padding: 16px !important;
}

/* Date Picker Card and Actions Styling */
.date-picker-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.date-picker-actions {
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
  padding: 8px 12px !important;
}

.date-picker-actions .v-btn {
  min-width: 80px;
  font-weight: 600;
  text-transform: none;
}

.date-picker-actions .v-btn--disabled {
  opacity: 0.5;
}
</style>
